import React from 'react';
import { formatMoney } from '../../Tools/helpers';

const FinancialSummary = ({globalSummary}) =>{

  return(
    <div className="bg-gray-50 rounded-lg p-4 mb-6 grid grid-cols-1 md:grid-cols-6 gap-4">
    <div className="border-r pr-4">
      <p className="text-sm text-gray-600">TOTAL</p>
      <p className="text-lg font-bold text-red-600">
        {formatMoney(globalSummary.total_amount || 0)}
      </p>
    </div>
    <div className="border-r pr-4">
      <p className="text-sm text-gray-600">Total del mes</p>
      <p className="text-lg font-bold">
      {formatMoney(globalSummary.total_month || 0)}
      </p>
    </div>
    <div className="border-r pr-4">
      <p className="text-sm text-gray-600">Meses anteriores</p>
      <p className="text-lg font-bold">
        {formatMoney(globalSummary.total_previous_months || 0)}
      </p>
    </div>
    <div className="border-r pr-4">
      <p className="text-sm text-gray-600">Recargo</p>
      <p className="text-lg font-bold">
        {formatMoney(globalSummary.late_fee_total || 0)}
      </p>
    </div>
    <div className="border-r pr-4">
      <p className="text-sm text-gray-600">Pendiente</p>
      <p className="text-lg font-bold">
        {formatMoney(globalSummary.remaining || 0)}
      </p>
    </div>
    <div className="border-r pr-4">
      <p className="text-sm text-gray-600">Saldo a favor</p>
      <p className="text-lg font-bold text-blue-700">
        {formatMoney(globalSummary.credit_balance || 0)}
      </p>
    </div>
  </div>
  )
}

export default FinancialSummary